import { render } from "./QuestionFeedbackList.vue?vue&type=template&id=c5dfb518&scoped=true"
import script from "./QuestionFeedbackList.vue?vue&type=script&lang=js"
export * from "./QuestionFeedbackList.vue?vue&type=script&lang=js"

import "./QuestionFeedbackList.vue?vue&type=style&index=0&id=c5dfb518&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5dfb518"]])

export default __exports__